import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/upload-illustration.jpg")